import React from 'react';
import { Typography } from '@mui/material';
import { round } from 'lodash';
import { mapDegreesCardinal } from '@surfline/web-common';
import { WindArrowIcon } from '@wavetrak/theme';

import styles from './WindStationCard.module.scss';

interface Props {
  windSpeedUnit: string;
  windSpeed: number;
  windDirection: number;
  isOffline: boolean;
  noValue: string;
}

const WindStationCardPredominantWindReading: React.FC<Props> = ({
  windSpeedUnit,
  windSpeed,
  windDirection,
  isOffline,
  noValue,
}: Props) =>
  isOffline ? (
    <>
      {noValue}
      <Typography variant="callout2" className={styles.windSpeedUnit} component="span">
        {windSpeedUnit}
      </Typography>
      <Typography variant="headline" component="span" className={styles.windDirection}>
        {' '}
        {noValue}
      </Typography>
    </>
  ) : (
    <>
      <Typography variant="title2" component="span">
        {round(windSpeed)}
      </Typography>
      <Typography variant="headline" className={styles.windSpeedUnit} component="span">
        {windSpeedUnit}
      </Typography>
      <Typography variant="headline" component="span" className={styles.windDirection}>
        {' '}
        {mapDegreesCardinal(windDirection)}
      </Typography>
      <WindArrowIcon rotation={windDirection - 180} size={20} />
    </>
  );

export default WindStationCardPredominantWindReading;
